/*******************************************************************************
Search Pages in Section Side Navigation
Watch for keystrokes in the section search input box.
*******************************************************************************/

import clearSectionSearch from './clear';
import getNoSearchResultsHTML from './get-no-results-html';

// Watch for keystrokes in the section search input box.
export default function watchSectionSearch(e) {
    const $searchBox = $(e.currentTarget);
    const searchTerm = $searchBox.val();
    const itemSelector = '.side-nav__group.is-section .side-nav__item';
    const $items = $(itemSelector);
    const $sectionHeads = $('.side-nav__sub-section');
    const enterKeyPressed = e.which === 13;

    // Remove the No Results panel (if it's there)
    $('.side-nav__no-results').remove();

    // Add the search class to the nav
    $('.side-nav').addClass('is-search');

    // Show the clear button
    $('.side-nav__clear-search').removeClass('hide');

    // If the input is empty (or the ESC key is pressed, then get rid of the clear button and show everything
    if (!searchTerm || e.which === 27) {
        clearSectionSearch();
        return;
    }

    // A collection of the links that matched the search term
    const visibleLinks = new Set();

    // Hide all the sub-section titles to start
    $sectionHeads.addClass('hide');

    // Hide all the link items to start
    $items.addClass('hide');

    // If the search string does not match part of the search term, hide the item. Otherwise show it.
    $items.each(function searchPages() {
        const $item = $(this);

        // Get the link element, text and actual link
        const $link = $item.find('.side-nav__link');
        const linkName = $link.text();
        const link = $link.attr('href');

        // Get the associated section head element and text
        const $sectionHead = $item.siblings('.side-nav__sub-section');
        const sectionHeadText = $sectionHead.text();

        // Does the search term match the link text?
        const searchMatchesLink = linkName.search(new RegExp(searchTerm, 'i')) >= 0;

        // Does the search term match the section heading?
        const searchMatchesHeading = sectionHeadText.search(new RegExp(searchTerm, 'i')) >= 0;

        // Was this link already matched in another section? (some links are listed under multiple sections)
        const linkAlreadyFound = visibleLinks.has(link);

        // If the search term is found within the link text or the section header (and is not already visible):
        // 1. Add the link to the list of visible links
        // 2. Show the link
        // 3. Show the header for the link's section
        if ((searchMatchesLink || searchMatchesHeading) && !linkAlreadyFound) {
            visibleLinks.add(link);
            $item.removeClass('hide');
            $sectionHead.removeClass('hide');
        }

        // Expand all the sub sections
        $('.side-nav__group').addClass('is-open is-search-result');
    });

    // Show the "No Results" indicator if the search failed to match any pages
    const numResults = $(itemSelector).not(':hidden').length;
    if (numResults === 0 && $('.side-nav__no-results').length === 0) {
        const noResultsMessageHTML = getNoSearchResultsHTML();
        $('.side-nav__middle').append(noResultsMessageHTML);
    }

    // If you press enter when there's only one item displaying (and it's a link), then go to the link
    // Or if there's a button, trigger a click on it (and also clear the filter)
    if (enterKeyPressed) {
        if ($(itemSelector).not(':hidden').find('a').length === 1) {
            window.location.href = $(`${itemSelector}:visible`).find('a').attr('href');
        }
    }
}
